import {useState} from 'react';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DescriptionIcon from '@mui/icons-material/Description';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import PhotoIcon from '@mui/icons-material/Photo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Stack from '@mui/material/Stack';
import TableRowsIcon from '@mui/icons-material/TableRows';
import Typography from '@mui/material/Typography';
import UploadIcon from '@mui/icons-material/Upload';

import config from '../../config/config';
import {useGetFilesQuery} from '../../redux/services/fileApi';
import FileUploadDialog from '../files/FileUploadDialog';

const getFileIcon = (file) => {
  const fileName = file?.s3_key || '';
  const fileExtension = fileName.split('.').pop().toLowerCase();
  switch (fileExtension) {
    case 'jpeg':
      return props => <PhotoIcon {...props} />;
    case 'jpg':
      return props => <PhotoIcon {...props} />;
    case 'png':
      return props => <PhotoIcon {...props} />;
    case 'pdf':
      return props => <PictureAsPdfIcon {...props} />;
    case 'doc':
      return props => <DescriptionIcon {...props} />;
    case 'docx':
      return props => <DescriptionIcon {...props} />;
    case 'txt':
      return props => <DescriptionIcon {...props} />;
    case 'xlsx':
      return props => <TableRowsIcon {...props} />;
    case 'xls':
      return props => <TableRowsIcon {...props} />;
    case 'csv':
      return props => <TableRowsIcon {...props} />;
    case 'mp3':
      return props => <AudioFileIcon {...props} />;
    case 'wav':
      return props => <AudioFileIcon {...props} />;
    case 'mp4':
      return props => <AudioFileIcon {...props} />;
    case 'mpeg':
      return props => <AudioFileIcon {...props} />;
    default:
      return props => <AttachFileIcon {...props} />;
  }
};

const FileItem = ({file}) => {
  const Icon = getFileIcon(file);
  return (
    <Box>
      <Stack direction='row' spacing={2} alignItems='center'>
        <Icon style={{color: config().colors.muted, fontSize: '1.2rem'}}/>
        <Typography variant='body1'>
          {file.title}
        </Typography>
        <IconButton
          variant='contained'
          color='primary'
          disabled={!file.url}
          size='small'
          href={file.url}
          target='_blank'
        >
          <DownloadIcon style={{fontSize: '1.2rem'}} />
        </IconButton>
      </Stack>
    </Box>
  );
};

const LeadFiles = ({ lead }) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const query = useGetFilesQuery(
    {lead_id: lead.id}, 
    {skip: !lead.id}
  );
  const files = query?.data?.data || [];
  return (
    <Box>
      <FileUploadDialog 
        leadId={lead.id}
        dialogIsOpen={dialogIsOpen}
        onClose={() => setDialogIsOpen(false)}
        afterSubmit={() => setDialogIsOpen(false)}
      />
      <Stack spacing={0.5}>
        <Stack direction='row' spacing={1} alignItems='center'>
          <AttachFileIcon style={{fontSize: '1.1rem'}}/>
          <Typography variant='h3'>Files</Typography>
          <Button
            size='small'
            onClick={() => setDialogIsOpen(true)}
          >
            <UploadIcon />{' '}
            Add
          </Button>
        </Stack>
        <Divider/>
        <Stack spacing={0.25}>
          {
            
            files.map(f => 
              <FileItem file={f} key={f.id} />
            )
          }
          {
            files?.length === 0 &&
            <Typography align='center' variant='body1' color='text.muted'>
              No files uploaded yet
            </Typography>
          }
        </Stack>
      </Stack>
    </Box>
  );
};

export default LeadFiles;